const checkImage = restaurant => {
  const ownerImage = restaurant.restaurantImage || [];
  const viewStyleSelected = restaurant.viewStyleSelected || {};
  const userPhoto = restaurant.photo || [];

  const haveCover =
    viewStyleSelected && !viewStyleSelected.random && viewStyleSelected.url;

  const allPhoto = ownerImage.length + userPhoto.length;
  const havePhoto = allPhoto >= 2;
  if (havePhoto || haveCover) {
    return true;
  }
  return false;
};

const getCover = (viewStyleSelected, photo, facebook, format = null) => {
  if (!viewStyleSelected.random) {
    const webpUrl = viewStyleSelected.webpUrl ? viewStyleSelected.webpUrl : "";
    const url = viewStyleSelected.url;
    return { webpUrl, url };
  } else if (viewStyleSelected.userImageUrl) {
    const webpUrl =
      format && viewStyleSelected[`userImageUrl${format}`]
        ? viewStyleSelected[`userImageUrl${format}`]
        : "";
    const url = viewStyleSelected.userImageUrl;
    return { webpUrl, url };
  } else if (photo && photo.length > 0) {
    const webpUrl = photo[0][`url${format}`] ? photo[0][`url${format}`] : "";
    const url = photo[0].image_url;
    return { webpUrl, url };
  } else if (facebook && facebook.cover && facebook.cover.source) {
    const webpUrl = "";
    const url = facebook.cover.source;
    return { webpUrl, url };
  }
  const webpUrl = viewStyleSelected.webpUrl ? viewStyleSelected.webpUrl : "";
  const url = viewStyleSelected.url;
  return { webpUrl, url };
};

export { checkImage, getCover };
